var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1503_2373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.375C30.7005 39.375 39.375 30.7005 39.375 20C39.375 9.29948 30.7005 0.625 20 0.625C9.29948 0.625 0.625 9.29948 0.625 20C0.625 30.7005 9.29948 39.375 20 39.375Z",
    fill: "#f4f5fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5481 31.5468C33.7411 29.1275 31.3948 27.1631 28.6955 25.8097C25.9963 24.4562 23.0185 23.7509 19.999 23.75C16.9794 23.7491 14.0012 24.4524 11.3011 25.8042C8.60102 27.156 6.25344 29.1189 4.44493 31.537C6.24424 33.9674 8.58799 35.9423 11.2883 37.3034C13.9885 38.6646 16.9701 39.3741 19.9941 39.375C23.018 39.376 26.0001 38.6683 28.7012 37.3089C31.4023 35.9494 33.7473 33.976 35.5481 31.5468Z",
    fill: "#FFDB11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21.25C24.1421 21.25 27.5 17.8921 27.5 13.75C27.5 9.60786 24.1421 6.25 20 6.25C15.8579 6.25 12.5 9.60786 12.5 13.75C12.5 17.8921 15.8579 21.25 20 21.25Z",
    fill: "#FFDB11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1503_2373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.293edfc1822f909cf03c2a58d3f88c81.svg";
export { ForwardRef as ReactComponent };